<template>
	<div class="app-container">
		<div class="card-container">
			<!-- <div v-for="(item, index) in appList" :key="index" @click="select(item)" class="card"> -->
			<div v-for="(item, index) in appList" :key="index" class="card">
				<div class="app-item" :style="{ color: item.color }">
					<p class="app-title">{{ item.title }}</p>
					<a v-if="!!item.pro" :href="item.pro" target="_blank"
						style="color:#3366FF;text-decoration: none;">正式地址</a>
					<br>
					<br>
					<a v-if="!!item.test" :href="item.test" target="_blank"
						style="color:#00CED1;text-decoration: none;">测试地址</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Index',
	props: {
		msg: String
	},
	data() {
		return {
			appList: [
				{
					title: "【2025】统一平台",
					tips: "统一平台",
					pro: "https://safety.hbxj.asia",
					test: "https://testsafety.hbxj.asia",
					color: '#222222'
				},				
				{
					title: "学习中心(todo)",
					tips: "学习中心"
				},
				{
					title: "律简阁",
					tips: "律简阁"
				},
				{
					title: "乐研考试系统",
					tips: "乐研考试系统"
				},
				{
					title: "隐患数据库",

					tips: "隐患数据库"
				},
				{
					title: "知识库(2025)",
					tips: "知识库(xj,xj123456)",
					pro: "https://wiki.hbxj.asia",
					color: '#222222'
				},

			]
		}
	},
	methods: {
		select: (value) => {
			window.open(value.url);
		}
	}
};
</script>
<style>
.app-container {
	padding: 60px 20px 0;
}

.card-container {
	display: flex;
	flex-wrap: wrap;
	/* 允许换行 */
	gap: 20px;

	.card {
		box-sizing: border-box;
		flex: 0 0 calc(25% - 15px);
		/* 四列布局，减去间距 */
		padding: 16px;
		margin-bottom: 20px;

		/* text-align: center; */
		cursor: pointer;
		background: var(--el-bg-color);
		border: 1px solid var(--el-border-color);
		border-radius: 4px;

		&:hover {
			color: var(--el-color-primary);
			background: var(--el-color-primary-light-9);
			border: 1px solid var(--el-color-primary-light-9);
			box-shadow: 0 0 4px 0 var(--el-color-primary);
		}

		&:nth-child(4n) {
			margin-right: 0;
			/* 每行最后一个元素不设置右边距 */
		}

		.app-title {
			font-size: 20px;
			font-weight: bold;
			text-align: center;
		}

		.tips {
			font-size: 12px;
			color: var(--el-color-primary);
			text-align: center;
		}
	}
}
</style>